import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import MoviesAndProgramsSearchForm from './movies-and-programs-search-form';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';
import {mappingColors, DrawLegend} from '../core/colorizeRows';

const servicesDataKey = 'moviesAndPrograms';

class MoviesAndPrograms extends Component {
    getColumnConfig() {
        const {detailLinkPrefix = ''} = this.props;
        const detailLink = `${detailLinkPrefix}/movies-and-programs`;

        return [
            {
                dataKey: 'title',
                formatter: 'moviesAndProgramsTitle',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId', 'tmsId', 'sourceId'],
                sortKey: 'title.sortable',
                title: 'Title',
                type: 'link',
                width: '17%',
            },
            {
                dataKey: 'episodeSeason',
                title: 'S',
                tooltip: 'Season Number',
                width: '5%',
            },
            {
                dataKey: 'episodeNumber',
                title: 'E',
                tooltip: 'Episode Number',
                width: '5%',
            },
            {
                dataKey: 'echostarContentType',
                title: 'Type',
                tooltip: 'Echostar Content Type',
                width: '6%',
            },
            {
                dataKey: 'echostarId',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId'],
                title: 'E* ID',
                tooltip: 'Echostar ID',
                type: 'link',
                width: '14%',
            },
            {
                dataKey: 'description',
                title: 'Description',
                width: '34%',
            },
            {
                dataKey: 'releaseYear',
                title: 'Released',
                tooltip: 'Release Year',
                type: 'string',
                width: '7%',
            },
            {
                dataKey: 'originalAirDate',
                title: 'Original Air',
                tooltip: 'Original Air Date',
                type: 'date',
                width: '12%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxResults: 10000,
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'description',
                'sportDatetime',
                'sportSeasonType',
                'episodeSeason',
                'programType',
                'genres',
                'runtime',
                'rating',
                'titleLanguages',
                'descriptionLanguage',
            ],
            isMapping: true,
        };
    }

    getTablewithsortProps() {
        return {
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            ...this.props,
        };
    }

    renderForm = () => <MoviesAndProgramsSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey} />;

    render() {
        const {searchData} = this.props;

        return (
            <div className="movies-and-programs">
                <ServicesExportPanelAction searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <div style={{display: 'flex'}}>
                    <SearchPagination {...this.getPaginationProps()} />
                    <div style={{marginTop: 8, marginBottom: 5}}>
                        <DrawLegend data={mappingColors} />
                    </div>
                </div>
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

MoviesAndPrograms.propTypes = {
    detailLinkPrefix: PropTypes.string,
    panelId: PropTypes.string,
    query: PropTypes.object,
    renderForm: PropTypes.func,
    searchData: PropTypes.array,
    tableWithSortProps: PropTypes.object,
    totalPages: PropTypes.number,
};

export default withSearch(MoviesAndPrograms, servicesDataKey);
